import i18next from "i18next";
import VueI18Next from "@panter/vue-i18next";
import Vue from "vue";
import env from "../util/environment";

class TranslateService {
  /**
   * Инициализируем i18next
   */
  constructor() {
    this.load = {
      init_locales: this._createPromise(),
      init_i18n: this._createPromise(),
    };
    Vue.use(VueI18Next);
    this.language = this.getCookieLanguage();
    this.i18nInit();

    this.loadTranslations();
  }

  i18nInit() {
    i18next.init(
      {
        lng: this.language,
        fallbackLng: ["en", "ru"],
      },
      () => {
        this.load.init_i18n.resolve();
      }
    );
  }

  _createPromise() {
    let resolver = false;
    let promise = {
      promise: new Promise(resolve => {
        resolver = resolve;
      }),
      resolve: false,
    };
    promise.resolve = resolver;

    return promise;
  }
  afterTranslationLoad() {
    const promise_list = [this.load.init_locales.promise, this.load.init_i18n.promise];
    return Promise.all(promise_list);
  }
  getLanguage() {
    return this.language;
  }
  /**
   *  Загружает переводы
   */
  loadTranslations() {
    let language_list = ["en", "de", "fr", "es", "cn", "ru"];
    let promise_list = [];

    language_list.forEach(lang => {
      promise_list.push(
        import(
          /* webpackMode: "eager"*/
          /* webpackChunkName: "translate" */
          `@/locales/${lang}/translation.json`
        ).then(file => {
          i18next.addResourceBundle(lang, "translation", file[lang].translation);
          return true;
        })
      );
    });
    Promise.all(promise_list).then(() => {
      this.load.init_locales.resolve();
    });
  }
  getCookie(name) {
    let matches = document.cookie.match(
      new RegExp("(?:^|; )" + name.replace("/([.$?*|{}()[]\\/+^])/g", "\\$1") + "=([^;]*)")
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
  getLib() {
    return new VueI18Next(i18next);
  }
  getCookieLanguage() {
    const fallback_language = env.isMailRu() ? "ru" : "en";

    return this.getCookie("cur_language") || fallback_language;
  }
  changeLanguage(language) {
    this.language = language;
    i18next.changeLanguage(language);
  }
}

export const translate_service = new TranslateService();

export const $t = (key, params = false) => i18next.t(key, params);
export const lang = translate_service.getLanguage();
export const change_language = language => translate_service.changeLanguage(language);
export default translate_service.getLib();
